class ScheduledBlock extends HTMLElement {
  constructor() {
    super();

    const startDate = parseInt(this.dataset.startDate, 10);
    const endDate = parseInt(this.dataset.endDate, 10);
    const secondStartDate = parseInt(this.dataset.secondStartDate, 10);
    const secondEndDate = parseInt(this.dataset.secondEndDate, 10);
    const now = Math.floor(Date.now() / 1000);
    const { requestMode } = this.dataset;
    const { showSection } = this.dataset;

    if (
      Number.isNaN(startDate) ||
      Number.isNaN(endDate) ||
      Number.isNaN(secondStartDate) ||
      Number.isNaN(secondEndDate) ||
      (startDate === 0 && endDate === 0 && secondStartDate === 0 && secondEndDate === 0) ||
      requestMode === 'true'
    ) {
      return;
    }

    const isInFirstRange = startDate !== 0 && endDate !== 0 && now >= startDate && now <= endDate;
    const isInSecondRange =
      secondStartDate !== 0 &&
      secondEndDate !== 0 &&
      now >= secondStartDate &&
      now <= secondEndDate;

    if (!isInFirstRange && !isInSecondRange) {
      this.remove();
      return;
    }

    if (requestMode === 'false' && showSection === 'false') {
      this.fetchScheduledContent();
    }
  }

  async fetchScheduledContent() {
    const { sectionId } = this.dataset;
    if (!sectionId) {
      return;
    }

    const newUrl = `?section_id=${sectionId}&show_this_section`;

    try {
      const response = await fetch(newUrl);
      if (!response.ok) {
        throw new Error(`Failed to fetch section: ${response.statusText}`);
      }

      const data = await response.text();
      this.replaceSectionContent(data);
    } catch (error) {
      console.error(error);
    }
  }

  replaceSectionContent(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    const newSection = doc.querySelector('.js-scheduled-block');

    if (!newSection) {
      return;
    }

    this.replaceWith(newSection);

    newSection.classList.add('scheduled-switched');
  }
}

customElements.define('scheduled-block', ScheduledBlock);
